import type { Candle } from '../types/index.js';

/**
 * Returns true when the timestamp falls inside the forex weekend closure.
 *
 *   - All of Saturday UTC
 *   - Friday >= 21:00 UTC
 *   - Sunday < 22:00 UTC
 *   - Monday < 08:00 UTC (TwelveData flat-fill persists until London open)
 *
 * Crypto must NOT use this — it runs 24/7.
 */
export function isForexClosedAt(unixSeconds: number): boolean {
  const d = new Date(unixSeconds * 1000);
  const day = d.getUTCDay();
  const hour = d.getUTCHours();
  if (day === 6) return true;
  if (day === 5 && hour >= 21) return true;
  if (day === 0 && hour < 22) return true;
  if (day === 1 && hour < 8) return true;
  return false;
}

/**
 * Returns true when an OHLC candle has impossible values (TwelveData has
 * been observed emitting `low: 0.00022041` for XAU/USD trading at 4500+).
 */
export function isCorruptCandle(c: Candle): boolean {
  if (c.open <= 0 || c.high <= 0 || c.low <= 0 || c.close <= 0) return true;
  if (c.low > c.high) return true;
  if (c.low < c.close * 0.5) return true;
  if (c.high > c.close * 2) return true;
  return false;
}
